<template>
  <div class="page-container">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <img src="/img/selo-color.svg" height="180" @click="$router.replace('main')"/>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="text-center">
        <h1 class="title dark-blue">Seja bem-vindo</h1>
        <h4 class="sub-title">Antes de começar quero te conhecer um pouco mais</h4>
      </div>
    </div>
    <div class="container">
      <button class="btn-block btn-dark-blue" @click.prevent="$router.push('/peso')">CLIQUE AQUI PARA
        COMEÇAR</button>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  data() {
    return {
    };
  },
  created() {

  },

  methods: {
  },
};
</script>

<style scoped>
.page-container {
  justify-content: center;
  min-height: 80vh !important;
}

.container {
  flex: 0.2;
}

.btn-dark-blue {
  font-size: 18px;
  padding: 10px 20px 10px 20px;
  border: 1px solid #0D4275;
  border-radius: 5px;
  background: #0D4275;
  color: #fff;
  box-shadow: 9px 12px 30px 0px rgba(0, 0, 0, 0.1),
    0 6px 20px 0 rgba(0, 0, 0, 0.1);
}

.btn-light-blue {
  font-size: 18px;
  padding: 10px 20px 10px 20px;
  border: 1px solid #3BAED9;
  border-radius: 5px;
  background: #3BAED9;
  color: #fff;
  box-shadow: 9px 12px 30px 0px rgba(0, 0, 0, 0.1),
    0 6px 20px 0 rgba(0, 0, 0, 0.1);
}


@media (max-width: 768px) {
  .desktop {
    display: none;
    height: 100vh;
  }
}

@media (min-width: 768px) {
  .mobile {
    display: none;
  }
}
</style>
